import React, { useState } from "react";
import { Button, Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { ROUTE_ROOT, ROUTE_SIGNUP } from "../../../constant/routes";
import {
  useValidateOtpMutation,
  useGenerateOtpMutation,
} from "../../../redux/services/auth";
import {
  setAuthenticated,
  setAccessToken,
  setStudentId,
  setUserId,
} from "../../../redux/features/authSlice";
import { useNavigate } from "react-router-dom";
import message from "antd/es/message";
import "./Otp.less";

const Otp = () => {
  const [otp, setOtp] = useState("");
  const { id } = useSelector((state) => state.auth);
  const [validateOtp, { isLoading }] = useValidateOtpMutation();
  const [generateOtp] = useGenerateOtpMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const phonenumber = useSelector((state) => state.auth.mobileNumber);

  const handleValidateOtp = async () => {
    try {
      const response = await validateOtp({ id, otp }).unwrap();

      if (response?.data?.is_sign_up) {
        dispatch(setAuthenticated(false));
        navigate(ROUTE_SIGNUP);
        message.error("User not found, please sign up");
      } else if (response?.data?.is_sign_up === false) {
        dispatch(setAuthenticated(true));
        dispatch(setAccessToken(response.data.access_token));
        dispatch(setUserId(response.data.user_id));
        dispatch(setStudentId(response.data.student_id));
        navigate(ROUTE_ROOT);
      } else {
        message.error("Invalid OTP");
      }
    } catch (error) {
      message.error("OTP validation failed");
    }
  };

  const handleResendOtp = async (e) => {
    try {
      const response = await generateOtp(phonenumber).unwrap();
      if (response?.data?.id) {
        message.success("OTP has been resent");
      } else {
        message.error("Failed to resend OTP");
      }
    } catch (error) {
      message.error(error);
    }
  };

  const onChange = (text) => {
    setOtp(text);
  };

  return (
    <div className='otp-container'>
      <div className='otp-form'>
        <h2 className='otp-heading'>Enter OTP</h2>
        <p className='otp-subheading'>OTP has been sent to {phonenumber}</p>
        <div className='otp-input-container'>
          <Input.OTP
            length={4}
            className='otp-input'
            formatter={(str) => str.toUpperCase()}
            onChange={onChange}
          />
        </div>
        <p className='otp-question'>Didn’t get OTP code?</p>
        <Button
          type='text'
          className='otp-resend-link'
          onClick={handleResendOtp}
        >
          Resend Code
        </Button>
        <Button
          type='primary'
          htmlType='submit'
          className='continue-button'
          onClick={handleValidateOtp}
          loading={isLoading}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default Otp;
